import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '@/components/Button/Button';
import { MODAL_TIMEOUT } from '@/config/constants';
import { AnalyticsEvent, useAnalytics } from '@/hooks/useAnalytics';
import { useCountdown } from '@/hooks/useCountdown';
import { useSocket } from '@/hooks/useSocket';
import { useWidgetState } from '@/hooks/useWidgetState';
import { chatModalState, sessionState, shouldDisplaySurveySelector, } from '@/state/session';
import { sleep } from '@/util/utils';
import styles from './Resolved.module.scss';
export const Resolved = () => {
    const { t } = useTranslation();
    const { trackEvent } = useAnalytics();
    const { closeWidget } = useWidgetState();
    const { reopenConversation, closeSession } = useSocket();
    const [session, setSessionState] = useRecoilState(sessionState);
    const keep_alive = session === null || session === void 0 ? void 0 : session.keep_alive;
    const remaining_keep_alive = session === null || session === void 0 ? void 0 : session.remaining_keep_alive;
    const { minutes, seconds } = useCountdown(remaining_keep_alive !== null && remaining_keep_alive !== void 0 ? remaining_keep_alive : keep_alive);
    const shouldDisplaySurvey = useRecoilValue(shouldDisplaySurveySelector);
    const setChatModal = useSetRecoilState(chatModalState);
    const handleClose = useCallback(async () => {
        setChatModal(null);
        trackEvent(AnalyticsEvent.PopoverResolvedEndChatClicked);
        await sleep(MODAL_TIMEOUT);
        if (shouldDisplaySurvey) {
            setChatModal("survey" /* ChatModal.Survey */);
        }
        else {
            closeSession();
            closeWidget();
        }
    }, [
        closeSession,
        closeWidget,
        setChatModal,
        shouldDisplaySurvey,
        trackEvent,
    ]);
    const handleCancel = useCallback(() => {
        trackEvent(AnalyticsEvent.PopoverResolvedContinueClicked);
        reopenConversation();
        setChatModal(null);
    }, [reopenConversation, setChatModal, trackEvent]);
    useEffect(() => {
        (async () => {
            if (minutes === 0 && seconds === 0) {
                setChatModal(null);
                await sleep(MODAL_TIMEOUT);
                setSessionState((prev) => (Object.assign(Object.assign({}, prev), { status: "expired" /* SessionStatus.Expired */ })));
                setChatModal("expired" /* ChatModal.Expired */);
            }
        })();
    }, [minutes, seconds, setChatModal, setSessionState]);
    return (_jsxs("div", { className: styles.form, children: [_jsx("div", { className: styles.title, children: _jsx("span", { children: t('modal.resolved_old') }) }), _jsxs("div", { className: styles.secondContainer, children: [_jsx("p", { className: styles.subtitle, children: t('modal.continue') }), _jsx("div", { className: styles.countdownWrapper, children: _jsxs("div", { className: styles.countdown, children: [_jsxs("span", { className: styles.box, children: [minutes && minutes < 10 && '0', minutes] }), _jsx("span", { className: styles.separator, children: ":" }), _jsxs("span", { className: styles.box, children: [seconds && seconds < 10 && '0', seconds] }), _jsx("span", { className: styles.time, children: "mins" }), _jsx("span", {}), _jsx("span", { className: styles.time, children: "sec" })] }) })] }), _jsxs("div", { className: styles.buttonContainer, children: [_jsx(Button, { onClick: handleClose, children: t('buttons.end_chat') }), _jsx(Button, { onClick: handleCancel, variant: "secondary", children: t('buttons.continue') })] })] }));
};
